var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"singlework container"},[_c('section',{staticClass:"three-img"},[_c('div',{staticClass:"img-left"},[_c('img',{attrs:{"src":_vm.ThreeImgleft,"alt":""}})]),_c('div',{staticClass:"img-right"},[_c('img',{attrs:{"src":_vm.ThreeImgRight,"alt":""}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }